<template>
 <div>
  <table-component
    :tableDivId="tableDivId"
     ref="table"
    :show-filter="false"
    :data="fetchData"
    table-class="table"
      >


    <table-column
      :label="$t('accounts.company_name')"
      show="company_name"
    />
    <table-column
      :label="$t('accounts.display_name')"
      show="name"
    />
    <table-column
      :label="$t('accounts.phone')"
      show="phone"
    />

    <table-column
    :label="$t('accounts.added_on')"
    show="user.formattedCreatedAt"
    />

    <table-column
      :label="$t('accounts.status')"
      show="user.UpperCaseStatus"
    />
     <table-column
      :label="$t('accounts.account_type')"
      show="user.UpperCaseAccountType"
    />
      </table-component>
 </div>
</template>
<script>
import moment from 'moment'
export default {
    props: {
        fetchData: { default: () => [], type: [Array, Function, Object] },
        tableDivId:{default: '', type:String }
    },

}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
